module.exports = __webpack_public_path__ + "static/img/social_10.5860e64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/launch/social/social_10.jpg
// module id = fF8X
// module chunks = 1